import { NotificationManager } from 'react-notifications';
import { roundNumberToNearestCent } from '@ami/react/core';

export function updateQuotePlusLeadTimesAndProducts(
  quote,
  updatedQuote,
  configuration,
  onQuoteUpdated,
  isFromStep2,
  isFromStep3,
  quoteProductDto,
  onQuoteProductDtoChange,
  onQuoteProductConfigurationUpdated,
  onIncompatibleStockItemsStateChange,
  onloadSharedDocuments,
  isStep3InventoryOnly = false
) {
  const leadTimeChanges = [];

  quote.products.forEach((quoteProduct) => {
    var leadTimeChange =
      quoteProduct.updateLeadTimeFromServerQuote(updatedQuote);
    if (leadTimeChange) leadTimeChanges.push(leadTimeChange);
  });


  if (quoteProductDto) {
    var leadTimeChange =
      quoteProductDto.updateLeadTimeFromProductConfiguration(configuration);
    if (leadTimeChange) leadTimeChanges.push(leadTimeChange);
  }

  onQuoteUpdated(updatedQuote);
  onQuoteProductConfigurationUpdated(configuration);

  if (isFromStep3) {
    if (quoteProductDto.inventoryItemId && !configuration.inventoryItems.some((x) => x.id === quoteProductDto.inventoryItemId)) {
      if (!isStep3InventoryOnly) {
        onQuoteProductDtoChange(null);
      }

      const { name } = configuration.productGroups.find(
        (x) => x.id === quoteProductDto.productGroupId
      );
      const { partNumber } = configuration.products.find(
        (x) => x.id === quoteProductDto.productId
      );
      onIncompatibleStockItemsStateChange({
        showIncompatibleStockItemsModal: true,
        incompatibleStockItems: [{ name, partNumber }],
      });
    }
  } else {
    // Notify about incompatible inventory
    const incompatibleStockItems = updatedQuote.updateProductInventoryItems(configuration.inventoryItems);

    if (incompatibleStockItems.length > 0) {
      if (isFromStep2) {
        NotificationManager.warning('Some incompatible stock items were converted to Build to Order', '', 3000);
      } else {
        onIncompatibleStockItemsStateChange({
          showIncompatibleStockItemsModal: true,
          incompatibleStockItems,
        });
      }
    }
  }

  // Notify about lead time changes
  if (leadTimeChanges.length === 0) {
    if (!isFromStep2 && !isStep3InventoryOnly) {
      NotificationManager.success('Lead times were not affected');
    }
  } else {
    leadTimeChanges.forEach((change) => {
      const descriptor = isFromStep3 ? '' : `for ${change.partNumber}`;
      if (change.newLeadTime && change.oldLeadTime) {
        if (change.newLeadTime < change.oldLeadTime) {
          NotificationManager.success(
            `Lead time ${descriptor} was decreased to ${change.newLeadTime} days`,
            '',
            7500
          );
        } else if (change.newLeadTime > change.oldLeadTime) {
          NotificationManager.warning(
            `Lead time ${descriptor} was increased to ${change.newLeadTime} days`,
            '',
            7500
          );
        }
      } else if (change.newLeadTime) {
        NotificationManager.success(
          `Lead time ${descriptor} was set to ${change.newLeadTime} days`,
          '',
          7500
        );
      } else {
        NotificationManager.success(
          `Lead time ${descriptor} was set to Call`,
          '',
          7500
        );
      }
    });
  }

  onloadSharedDocuments(updatedQuote);
}
